<script>
  import { onMount } from "svelte";
  import tmwfLogo from "../assets/img/tmwf_mini_icon.png";
  import userIcon from "../assets/img/user-check.png";
  import wifiIconGreen from "../assets/img/wifi_green.png";
  import wifiIconRed from "../assets/img/wifi_red.png";
  import buyDataIcon from "../assets/img/buy_data.png";
  import loadDataIcon from "../assets/img/load_voucher.png";
  import opentimeBanner from "../assets/img/opentime_banner.png";
  import {
    getHotspotData,
    getActiveAllocation,
    getAccount,
    getCellphoneByMAC,
  } from "./utils.svelte.js";

  const baseURL = import.meta.env.VITE_BASE_URL;

  // Props
  export let store;

  let accountPin = null;

  let loginForm;

  let voucherExpires = null;

  let days = 0;
  let hours = 0;
  let minutes = 0;

  let openTimeCurrentlyAvailable = false;
  let openTimeDisplayBanner = false;
  let openTimeGranted = false;
  let openTimeAlreadyRedeemed = false;

  let activeAllocation = false;

  let voucherCode = "";
  let intervalId = null;

  const handleVoucherSubmit = (e) => {
    e.preventDefault();
    if (voucherCode.toLowerCase() === "freehour") {
      minutes += 60; // Add 60 minutes
      voucherCode = "";
      alert("Voucher redeemed successfully! 60 minutes added to your balance.");
    } else {
      alert("Invalid voucher code.");
    }
  };

  async function checkActiveAllocation(cellphone) {
    const activeAllocationCall = await getActiveAllocation(cellphone);

    if (activeAllocationCall) {
      activeAllocation = true;
    } else {
      activeAllocation = false;
    }
  }

  async function submitLoginForm() {
    await getHotspotData();

    await checkActiveAllocation(store.cellphone);
    if (store.isAuthenticatedOnHotspot === false && activeAllocation != false) {
      if (loginForm) {
        loginForm.submit();
      }
    }
  }

  async function getDevice() {
    try {
      const response = await fetch(`${baseURL}device/${store.macAddress}/`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (response.status === 200) {
        const data = await response.json();
        return data;
      } else if (response.status === 401) {
        return null;
      }
    } catch (error) {
      console.error("Error", error);
    }
  }

  async function checkOpenTimeAvailability() {
    try {
      let response = await fetch(`${baseURL}opentime/availability/`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 200) {
        openTimeCurrentlyAvailable = true;
      } else if (response.status === 409) {
        openTimeCurrentlyAvailable = false;
      }
    } catch (error) {
      openTimeCurrentlyAvailable = false;
    }
  }

  async function determineOpenTimeWorthiness() {
    if (
      store.isConnectedToHotspot &&
      !voucherExpires &&
      openTimeCurrentlyAvailable
    ) {
      openTimeDisplayBanner = true;
    }
  }

  async function clickOpenTimeBanner() {
    let url = `${baseURL}opentime/allocate/?user_mac=${store.macAddress}`;
    let response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (response.status === 200) {
      openTimeGranted = true;
      openTimeDisplayBanner = false;
    } else if (response.status === 403) {
      openTimeAlreadyRedeemed = true;
    }
  }

  async function dataTimer() {
    const deviceInfo = await getDevice();

    try {
      voucherExpires = new Date(deviceInfo.allocation.date_expires);
    } catch {
      voucherExpires = null;
    }

    if (deviceInfo.allocation) {
      voucherExpires = new Date(deviceInfo.allocation.date_expires);
    } else {
      voucherExpires = null;
    }
    const now = new Date();

    if (voucherExpires > now) {
      const timeDiff = voucherExpires.getTime() - now.getTime();

      days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      intervalId = setInterval(() => {
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else if (days > 0) {
          days--;
          hours = 23;
          minutes = 59;
          seconds = 59;
        } else {
          clearInterval(intervalId);
        }
      }, 1000);
    }
  }

  async function getUserPin(cellphone) {
    try {
      const account = await getAccount(cellphone);
      accountPin = account.pin;
    } catch (error) {
      console.log(error);
      accountPin = null;
    }
  }

  // Update widget with connection status
  $: connectedWidgetGreen =
    store.isAuthenticatedOnHotspot === true &&
    store.isConnectedToHotspot === true &&
    activeAllocation === true;

  onMount(async () => {
    // Update cellphone number if null
    if (store.cellphone === null) {
      await getHotspotData();

      let cellphone = await getCellphoneByMAC(store.macAddress);
      store.setCellphone(cellphone);
    }

    await getUserPin(store.cellphone);

    checkActiveAllocation(store.cellphone);

    submitLoginForm();

    await dataTimer();

    await checkOpenTimeAvailability();
    await determineOpenTimeWorthiness();
  });
</script>

<form
  bind:this={loginForm}
  name="redirect"
  action="//hotspot.toomuchwifi.co.za/login"
  method="post"
  class="hidden"
>
  <!-- <input type="hidden" name="username" value="0747202605" /> -->
  <!-- <input type="hidden" name="password" value="testingaccount" /> -->
  <input
    type="hidden"
    name="username"
    value="{store.cellphone}@connect.toomuchwifi.co.za"
  />
  <input type="hidden" name="password" value={accountPin} />
</form>

<div class="container flex flex-col h-screen">
  <div
    class="flex-col justify-center mx-auto items-center text-center p-3 my-10 border border-gray-300 rounded-md w-11/12 max-w-[30em]"
  >
    <div class="bg-[#009946] grid size-12 rounded-full mx-auto">
      <img src={userIcon} alt="User Icon" class="m-auto w-1/2" />
    </div>
    <span class="font-bold text-lg tracking-wider">{store.cellphone}</span>
  </div>

  {#if openTimeDisplayBanner}
    <div class="mb-7 mx-auto w-5/6 max-w-[30em]">
      <button class="hover:cursor-pointer" on:click={clickOpenTimeBanner}>
        <img
          src={opentimeBanner}
          alt="OpenTime Banner"
          class="mx-auto w-full"
        />
      </button>
    </div>
  {/if}

  <div class="flex justify-center">
    <h2 class="font-bold mb-4 text-xl">Hotspot Time Remaining</h2>
  </div>

  <div
    class="bg-[#313131] flex mx-auto rounded-xl shadow-xl my-4 py-[2em] justify-center w-5/6"
  >
    <div class="columns-1">
      <img src={tmwfLogo} alt="TooMuchWifi Logo" class="mb-2 mx-auto w-1/2" />

      <div class="flex justify-around">
        <div class="flex flex-col items-center">
          <span id="days" class="font-bold text-5xl text-white">
            {String(days).padStart(2, "0")}
          </span>
          <span class="text-sm text-white">Days</span>
        </div>
        <div class="text-4xl text-white">:</div>
        <div class="flex flex-col items-center">
          <span id="hours" class="font-bold text-5xl text-white">
            {String(hours).padStart(2, "0")}
          </span>
          <span class="text-sm text-white">Hours</span>
        </div>
        <div class="text-4xl text-white">:</div>
        <div class="flex flex-col items-center">
          <span id="minutes" class="font-bold text-5xl text-white">
            {String(minutes).padStart(2, "0")}
          </span>
          <span class="text-sm text-white">Minutes</span>
        </div>
      </div>
    </div>
  </div>

  {#if connectedWidgetGreen}
    <div
      class="bg-[#009946] flex flex-row my-8 mx-auto p-1.5 rounded-full text-white w-56"
    >
      <div class="bg-white grid h-9 w-9 mr-2 rounded-full">
        <img src={wifiIconGreen} alt="WiFi symbol green" class="h-7 m-auto" />
      </div>
      <h1 class="font-semibold my-auto text-sm">Connected to hotspot</h1>
    </div>
  {:else}
    <button
      on:click={submitLoginForm}
      class="bg-[#dd281d] flex flex-row my-8 mx-auto p-1.5 rounded-full text-white w-56"
    >
      <div class="bg-white grid h-9 w-9 mr-2 rounded-full">
        <img src={wifiIconRed} alt="WiFi symbol red" class="h-6 m-auto" />
      </div>
      <h1 class="font-semibold ml-6 my-auto text-sm">Disconnected</h1>
    </button>
  {/if}

  <div class="flex-row flex justify-center">
    <button
      class="bg-[#408bcc] mr-2 py-3 px-2 rounded-lg shadow-md w-28"
      on:click={() => store.setState("BUNDLE_PURCHASE")}
    >
      <img src={buyDataIcon} alt="Buy data" class="mx-auto h-6 m-1" />
      <p class="font-bold text-white text-xs whitespace-nowrap">Buy Voucher</p>
    </button>
    <button
      class="bg-[#408bcc] ml-2 py-3 px-2 rounded-md shadow-md w-28"
      on:click={() => store.setState("VOUCHER_REDEMPTION")}
    >
      <img src={loadDataIcon} alt="Load data" class="mx-auto h-6 m-1" />
      <p class="font-bold text-white text-xs whitespace-nowrap">Load Voucher</p>
    </button>
  </div>

  <div class="my-2"></div>

  <div class="mb-2 mt-auto text-center text-sm text-gray-500 w-full">
    <button class="underline text-[#408bcc]" on:click={store.setState("HELP")}
      >Need help?</button
    >
    <p>&copy; 2024 TooMuchWifi. All rights reserved.</p>
  </div>
</div>
